import React, { lazy } from 'react';
import { CheckCircle2Icon, LockIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
export function OfferSection() {
  const items = [{
    title: 'Oltre 50 Ricette di Plumcake Irresistibili',
    value: '79,99 €',
    isBonus: false
  }, {
    title: 'Ricettario Speciale di Plumcake Salati',
    value: '9,99 €',
    isBonus: true
  }, {
    title: 'Guida a Glasse e Coperture',
    value: '12,99 €',
    isBonus: true
  }, {
    title: 'Kit per Iniziare a Vendere',
    value: '14,99 €',
    isBonus: true
  }, {
    title: 'Tabella di Conversioni e Trucchi',
    value: '9,99 €',
    isBonus: true
  }];
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        {/* Main Offer Card */}
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden relative" data-id="element-139">
          {/* Header */}
          <div className="bg-green-500 text-white text-center py-4" data-id="element-140">
            <h2 className="text-2xl md:text-3xl font-bold uppercase tracking-wide" data-id="element-141">
              Accedi Ora al Mega-Pack
            </h2>
          </div>

          <div className="p-6 md:p-10 flex flex-col md:flex-row gap-8" data-id="element-142">
            {/* Left Col: Image & List */}
            <div className="w-full md:w-1/2" data-id="element-143">
              {/* Mini Fan */}
              <div className="relative h-[200px] w-full mb-8" data-id="element-144">
                <img src={CONSTANTS.IMAGES.BONUS_1} alt="B1" className="absolute top-[10%] left-[5%] w-[25%] -rotate-12 shadow-md rounded" loading="lazy" data-id="element-145" />
                <img src={CONSTANTS.IMAGES.BONUS_2} alt="B2" className="absolute top-[5%] left-[20%] w-[25%] -rotate-6 shadow-lg rounded z-10" loading="lazy" data-id="element-146" />
                <img src={CONSTANTS.IMAGES.BONUS_4} alt="B4" className="absolute top-[10%] right-[5%] w-[25%] rotate-12 shadow-md rounded" loading="lazy" data-id="element-147" />
                <img src={CONSTANTS.IMAGES.BONUS_3} alt="B3" className="absolute top-[5%] right-[20%] w-[25%] rotate-6 shadow-lg rounded z-10" loading="lazy" data-id="element-148" />
                <img src={CONSTANTS.IMAGES.MAIN} alt="Main" className="absolute top-0 left-1/2 -translate-x-1/2 w-[40%] shadow-xl rounded z-20" loading="lazy" data-id="element-149" />
              </div>

              <div className="space-y-3" data-id="element-150">
                {items.map((item, idx) => <div key={idx} className="flex items-start gap-2 text-sm" data-id="element-151">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-152" />
                    <div className="flex-grow" data-id="element-153">
                      <span className="font-medium text-gray-800" data-id="element-154">
                        {item.title}
                      </span>
                      {item.isBonus && <span className="ml-2 inline-block bg-red-100 text-red-700 text-[10px] font-bold px-1.5 py-0.5 rounded uppercase" data-id="element-155">
                          Gratis
                        </span>}
                    </div>
                    <span className="text-gray-400 line-through whitespace-nowrap" data-id="element-156">
                      {item.value}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Right Col: Price & CTA */}
            <div className="w-full md:w-1/2 flex flex-col items-center justify-center text-center bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-157">
              <div className="mb-2" data-id="element-158">
                <span className="text-gray-500" data-id="element-159">Valore totale reale: </span>
                <span className="text-gray-400 line-through font-medium" data-id="element-160">
                  {CONSTANTS.PRICING.TOTAL_VALUE} €
                </span>
              </div>
              <div className="mb-4" data-id="element-161">
                <span className="text-gray-600" data-id="element-162">Prezzo originale: </span>
                <span className="text-red-500 line-through decoration-red-500 font-bold" data-id="element-163">
                  {CONSTANTS.PRICING.ORIGINAL} €
                </span>
              </div>

              <div className="mb-2" data-id="element-164">
                <span className="text-sm font-bold text-green-600 uppercase tracking-wider" data-id="element-165">
                  👉 Oggi tuo a soli
                </span>
              </div>

              <div className="flex items-start justify-center mb-2" data-id="element-166">
                <span className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-none" data-id="element-167">
                  {CONSTANTS.PRICING.SALE}
                </span>
                <span className="text-2xl font-bold text-gray-500 mt-1 ml-1" data-id="element-168">
                  €
                </span>
              </div>

              <div className="bg-green-100 text-green-800 font-bold px-4 py-1 rounded-full mb-6" data-id="element-169">
                Risparmi l'{CONSTANTS.PRICING.SAVINGS_PERCENT}% oggi
              </div>

              <div className="mb-6 w-full" data-id="element-170">
                <CountdownTimer variant="dark" data-id="element-171" />
              </div>

              <a href={CONSTANTS.PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="w-full block bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 rounded-2xl shadow-[0_10px_25px_rgba(34,197,94,0.4)] transition-all transform hover:scale-105 animate-pulse-fast text-center" data-id="element-172">
                ACQUISTA ORA
              </a>

              <div className="mt-4 w-full" data-id="element-173">
                <PaymentBadges data-id="element-174" />
              </div>
            </div>
          </div>
        </div>

        {/* Trust Elements Below Card */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-175">
          {/* Trust Box */}
          <div className="bg-green-50 rounded-2xl p-6 border border-green-100 space-y-4" data-id="element-176">
            <div className="flex items-start gap-3" data-id="element-177">
              <LockIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-178" />
              <div data-id="element-179">
                <h4 className="font-bold text-green-900" data-id="element-180">
                  Transazione Sicura al 100%
                </h4>
                <p className="text-sm text-green-800/80" data-id="element-181">
                  Protetto con crittografia SSL a 256 bit
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-182">
              <ShieldIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-183" />
              <div data-id="element-184">
                <h4 className="font-bold text-green-900" data-id="element-185">Garanzia 45 Giorni</h4>
                <p className="text-sm text-green-800/80" data-id="element-186">
                  Soddisfatti o rimborsati. Nessun rischio.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-187">
              <CreditCardIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-188" />
              <div data-id="element-189">
                <h4 className="font-bold text-green-900" data-id="element-190">Pagamento Unico</h4>
                <p className="text-sm text-green-800/80" data-id="element-191">
                  Nessun abbonamento. Nessun costo nascosto.
                </p>
              </div>
            </div>
          </div>

          {/* Steps Box */}
          <div className="bg-gray-100 rounded-2xl p-6 border border-gray-200" data-id="element-192">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-193">
              Cosa succede dopo l'acquisto?
            </h4>
            <div className="space-y-4" data-id="element-194">
              <div className="flex items-center gap-3" data-id="element-195">
                <div className="w-6 h-6 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-196">
                  1
                </div>
                <p className="text-sm text-gray-700" data-id="element-197">
                  Clicca sul pulsante ACQUISTA ORA
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-198">
                <div className="w-6 h-6 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-199">
                  2
                </div>
                <p className="text-sm text-gray-700" data-id="element-200">
                  Completa il pagamento sicuro
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-201">
                <div className="w-6 h-6 rounded-full bg-green-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0" data-id="element-202">
                  3
                </div>
                <p className="text-sm text-gray-900 font-medium" data-id="element-203">
                  Ricevi subito l'email con il download
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}